var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadershipDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 14.7498C13.2877 14.7498 14.3309 13.7067 14.3309 12.4198C14.3309 11.133 13.2877 10.0898 12.0009 10.0898C10.7141 10.0898 9.6709 11.133 9.6709 12.4198C9.6709 13.7067 10.7141 14.7498 12.0009 14.7498Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1709 20.0197V18.5697C8.1709 16.4597 9.8809 14.7397 12.0009 14.7397C14.1209 14.7397 15.8309 16.4497 15.8309 18.5697V20.0197",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41086 15.9799C6.39393 15.9799 7.19086 15.183 7.19086 14.1999C7.19086 13.2169 6.39393 12.4199 5.41086 12.4199C4.42779 12.4199 3.63086 13.2169 3.63086 14.1999C3.63086 15.183 4.42779 15.9799 5.41086 15.9799Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48047 20.02V18.91C2.48047 17.29 3.79047 15.98 5.41047 15.98C5.98047 15.98 6.52047 16.14 6.97047 16.43",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5905 15.9799C19.5736 15.9799 20.3705 15.183 20.3705 14.1999C20.3705 13.2169 19.5736 12.4199 18.5905 12.4199C17.6075 12.4199 16.8105 13.2169 16.8105 14.1999C16.8105 15.183 17.6075 15.9799 18.5905 15.9799Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5203 20.02V18.91C21.5203 17.29 20.2103 15.98 18.5903 15.98C18.0203 15.98 17.4803 16.14 17.0303 16.43",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82992 5.79004L8.42992 6.98004L9.73992 7.18004L8.79992 8.12004L9.00992 9.43004L7.82992 8.82004L6.64992 9.43004L6.86992 8.12004L5.91992 7.18004L7.23992 6.98004L7.82992 5.79004Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.12 3.97998L15.72 5.16998L17.03 5.36998L16.08 6.29998L16.3 7.60998L15.12 6.99998L13.94 7.60998L14.16 6.29998L13.21 5.36998L14.52 5.16998L15.12 3.97998Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadershipDevelopment);
export default __webpack_public_path__ + "static/media/Leadership Development.3dcf2976b0c0551b38daec410cfc7df8.svg";
export { ForwardRef as ReactComponent };